import _actions_set_data from './_actions/set/data.js'
import _actions_get_documentNumber from './_actions/get/documentNumber.js'
import _actions_save from './_actions/save.js'
import _actions_create from './_actions/create.js'
import _actions_change from './_actions/change.js'
import _getters_paymentType from './_getters/paymentType.js'
import _getters_paymentOperation from './_getters/paymentOperation.js'
import _getters_paymentAccount from './_getters/paymentAccount.js'
import _getters_form from './_getters/form.js'
import _getters_data from './_getters/data.js'
import _getters_c_type from './_getters/c_type.js'
import _getters_currency from './_getters/currency.js'
import _getters_cash from './_getters/cash.js'
import _mutations_set_data from './_mutations/set/data.js'
import _mutations_set from './_mutations/set.js'
import _mutations_clear from './_mutations/clear.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clear: _mutations_clear,
        set: _mutations_set,
        set_data: _mutations_set_data,
    },
    getters:{
        cash: _getters_cash,
        currency: _getters_currency,
        c_type: _getters_c_type,
        data: _getters_data,
        form: _getters_form,
        paymentAccount: _getters_paymentAccount,
        paymentOperation: _getters_paymentOperation,
        paymentType: _getters_paymentType,
    },
    actions:{
        change: _actions_change,
        create: _actions_create,
        save: _actions_save,
        get_documentNumber: _actions_get_documentNumber,
        set_data: _actions_set_data,
    },
}